import React from 'react'
import { containerIds } from 'modules/ui'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import Path from 'routes/path'

export default class AccountMenu extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    e.preventDefault()
    const { ui, data, actions } = this.props
    actions.setUIState(containerIds.BUSINESS_HEADER, { showMenu: !ui.showMenu })
  }

  render() {
    const { data, ui, config } = this.props
    const currentUser = data.viewer
    const companies = data.viewer.companies
    const company = data.company

    return (
      <ul className="site-header__nav sm-hide">
        <li>
          <a
            href="#"
            className="site-header__nav-user business-header__account"
            onClick={this.onClick}
          >
            <img
              src={company ? company.profileImage : currentUser.profileImage}
              alt={currentUser.name}
              className="site-header__nav-user-icon"
            />
            <p className="site-header__nav-user-name link-black link-borderless">
              <i className="fa fa-caret-down business-header__text" />
            </p>
          </a>
          <div
            className="baloon business-header__baloon site-header__nav-baloon"
            style={{ display: ui.showMenu ? 'block' : 'none' }}
          >
            <div className="baloon-inner">
              <ul>
                <li className="site-header__nav-baloon-user business-header__name">
                  {company ? company.name : currentUser.name}
                </li>
                <li className="site-header__nav-baloon-menu">
                  <a
                    href={Path.logoutAccount(config.URL || '')}
                    className="link-black link-borderless"
                  >
                    {i18n.t('page.shared.l_00069')}
                    <i className="fa fa-angle-right fr" />
                  </a>
                </li>
                <li>
                  <p className="site-header__nav-baloon-title">
                    {i18n.t('page.shared.l_00070')}
                  </p>
                  <ul>
                    <li className="site-header__nav-baloon-menu">
                      <a
                        href={wwwUrl('/')}
                        className="link-black link-borderless"
                      >
                        SPACEMARKET
                        <i className="fa fa-angle-right fr" />
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <p className="site-header__nav-baloon-title">
                    {i18n.t('spacemarket_busiess')}
                  </p>
                  <div className="site-header__nav-baloon-menu">
                    {((companies || {}).results || []).map(result => (
                      <a
                        key={result.id}
                        href={Path.employees(result.username)}
                        className="link-black link-borderless"
                      >
                        <img
                          src={result.profileImage}
                          alt={result.name}
                          className="site-header__nav-baloon-business-img"
                        />
                        <p className="site-header__nav-baloon-business-text">
                          {result.name}
                        </p>
                        <div className="site-header__nav-baloon-business-angle">
                          <i className="fa fa-angle-right" />
                        </div>
                      </a>
                    ))}
                  </div>
                </li>
                <li>
                  <p className="site-header__nav-baloon-title">
                    {i18n.t('page.header.personalAccount')}
                  </p>
                  <div className="site-header__nav-baloon-menu">
                    <a
                      href={wwwUrl('/dashboard')}
                      className="link-black link-borderless"
                    >
                      <img
                        src={currentUser.profileImage}
                        alt={currentUser.name}
                        className="site-header__nav-baloon-business-img"
                      />
                      <p className="site-header__nav-baloon-business-text">
                        {currentUser.name}
                      </p>
                      <div className="site-header__nav-baloon-business-angle">
                        <i className="fa fa-angle-right" />
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    )
  }
}
